import { render, staticRenderFns } from "./HistoryColor.vue?vue&type=template&id=e80a6ab0&scoped=true&"
import script from "./HistoryColor.vue?vue&type=script&lang=js&"
export * from "./HistoryColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80a6ab0",
  null
  
)

export default component.exports